export const locales = {
  en: require('./en')
};

export default {
  '抱歉，你访问的页面出错了。': '抱歉，你访问的页面出错了。'
};
